import { Injectable, inject } from '@angular/core';
import { injectMutation, injectQuery } from '@tanstack/angular-query-experimental';
import { firstValueFrom } from 'rxjs';

import { Client } from '../../api/api-clients';
import type { AppPayment } from '../models/payment.model';
import { toAppPayment } from '../models/payment.model';
import { paymentKeys } from './query-keys';

@Injectable({ providedIn: 'root' })
export class PaymentService {
  private readonly client = inject(Client);

  /**
   * Devuelve el último pago del perfil autenticado (completado o pendiente).
   * Retorna `null` si el perfil no ha iniciado ningún pago (204 No Content).
   */
  readonly myPayment = injectQuery(() => ({
    queryKey: paymentKeys.mine(),
    queryFn: async (): Promise<AppPayment | null> => {
      try {
        const result = await firstValueFrom(this.client.payment());
        return result ? toAppPayment(result) : null;
      } catch (err: any) {
        if (err?.status === 204) return null;
        throw err;
      }
    },
  }));

  /**
   * Crea una sesión de Stripe Checkout y redirige al usuario a la URL de pago.
   */
  readonly createCheckout = injectMutation(() => ({
    mutationFn: () => firstValueFrom(this.client.checkout()),
    onSuccess: (result) => {
      if (result.url) {
        window.location.href = result.url;
      }
    },
  }));

  /**
   * Crea una sesión del portal de Stripe y redirige al usuario a la URL de gestión de suscripción.
   */
  readonly createPortalSession = injectMutation(() => ({
    mutationFn: () => firstValueFrom(this.client.portal()),
    onSuccess: (result) => {
      if (result.url) {
        window.location.href = result.url;
      }
    },
  }));
}
